var map = {
	"./Insurance.png": "91fa",
	"./platform-icon-1.png": "4853",
	"./platform-icon-2.png": "122f",
	"./platform-icon-3.png": "c76f",
	"./platform-icon-4.png": "611b",
	"./product.png": "d2693",
	"./profile-1.png": "878a",
	"./profile-2.png": "2fc7",
	"./profile-3.png": "b424",
	"./profile-4.png": "32ff",
	"./profile-5.png": "dcce",
	"./top-bg.png": "3201"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "af6d";